// extracted by mini-css-extract-plugin
export default {"signInForm":"SignIn_signInForm__xH6D4","leftGrid":"SignIn_leftGrid__hhT8T","loginBgVideo":"SignIn_loginBgVideo__PK7Z2"};